import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_73: FaireProductEntity = {
  token: "starter_collection_73",
  type: "product",
  name: "Albacore Tuna in Olive Oil",
  brandName: "Fishwife",
  imageUrl:
    '"https://cdn.faire.com/fastly/16fe9209232b5357fac6f15b656f8cecd91d822c7573c9168d7ffec668301e09.jpeg?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=2589',
  priceDollars: 12,
  msrpDollars: 24,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
